<!-- Uudise lisamise vaheleht -->
<template>
  <page-header class="px-10">
    <h1 >Uus uudis</h1>
  </page-header>
  <v-sheet class="post-body d-flex justify-center pa-10 ga-10">
      <div class="products">
        <v-form ref="form">
          <v-file-input
              v-model="selectedImage"
              label="Sisesta pilt"
              variant="outlined"
              prepend-icon="mdi-camera"
              accept="image/*"
              :loading="uploadingImage"
              @update:modelValue="uploadImage"
          ></v-file-input>
          <p v-if="uploadError" class="error-text">{{ uploadError }}</p>
          <v-btn
              class="mb-4"
              color="eraklient"
              variant="outlined"
              :loading="loadingCloudinaryImages"
              @click="fetchCloudinaryImages"
          >
            Lae pildid
          </v-btn>
          <p v-if="cloudinaryError" class="error-text">{{ cloudinaryError }}</p>
          <div v-if="cloudinaryImages.length" class="cloudinary-gallery">
            <button
                v-for="image in cloudinaryImages"
                :key="image.public_id"
                type="button"
                class="cloudinary-item"
                :class="{ selected: post.image === image.url }"
                @click="post.image = image.url"
            >
              <img :src="image.url" :alt="image.public_id"/>
              <span
                  class="cloudinary-delete"
                  @click.stop.prevent="openDeleteCloudinaryDialog(image)"
              >
                <v-icon size="16">mdi-delete</v-icon>
              </span>
            </button>
          </div>
          <v-dialog v-model="deleteImageDialog" width="auto" transition="none">
            <v-card min-width="360">
              <v-toolbar color="white" title="Kinnitus">
                <v-btn icon="mdi-close" @click="closeDeleteCloudinaryDialog"></v-btn>
              </v-toolbar>
              <v-card-text>
                <v-alert type="warning" variant="tonal" border="start" prominent>
                  Kas oled kindel, et soovid selle pildi kustutada?
                </v-alert>
              </v-card-text>
              <v-divider></v-divider>
              <div class="ma-4">
                <v-btn
                    class="text-none mr-4 font-weight-bold"
                    color="error"
                    min-width="92"
                    rounded
                    :loading="deletingPublicId === pendingDeleteImage?.public_id"
                    @click="confirmDeleteCloudinaryImage"
                >
                  Jah
                </v-btn>
                <v-btn class="text-none font-weight-bold" min-width="92" rounded @click="closeDeleteCloudinaryDialog">
                  Ei
                </v-btn>
              </div>
            </v-card>
          </v-dialog>
          <v-btn
              v-if="post.image"
              class="mb-4"
              color="error"
              variant="outlined"
              size="small"
              @click="post.image = ''"
          >
            Eemalda pilt
          </v-btn>
          <v-tabs v-model="tab" bg-color="eraklient">
            <v-tab value="one" @click="changeLocale('et')">EST</v-tab>
            <v-tab value="two" @click="changeLocale('en')">ENG</v-tab>
            <v-tab value="three" @click="changeLocale('ru')">RUS</v-tab>
          </v-tabs>
          <v-window class="py-5" v-model="tab">
            <v-window-item value="one">
              <v-text-field
                  v-model=post.header
                  label="Pealkiri"
                  :rules="rules"
                  variant="outlined"
              ></v-text-field>
              <tiptap v-model="post.body"/>
            </v-window-item>
            <v-window-item value="two">
              <v-text-field
                  v-model=post.header_en
                  label="Pealkiri(en)"
                  variant="outlined"
              ></v-text-field>
              <tiptap v-model="post.body_en"/>
            </v-window-item>
            <v-window-item value="three">
              <v-text-field
                  v-model=post.header_ru
                  label="Pealkiri"
                  variant="outlined"
              ></v-text-field>
              <tiptap v-model="post.body_ru"/>
            </v-window-item>
          </v-window>
        </v-form>
        <v-btn color="success" @click="addPost" class="mt-2">Lisa</v-btn>
      </div>
      <div class="products preview-post-column">
        <v-sheet class="post-container pa-16 preview-post-container">
          <v-list-item-title class="text-h4 font-weight-bold py-6 text-center">{{ getHeader(post) }}</v-list-item-title>
          <img v-if="post.image" alt="" :src="post.image" />
          <img v-else alt="lõhnakas logo" src="../../assets/images/lohnakas.webp" />
          <div class="tiptap tiptap-editor" v-html=getBody(post)></div>
        </v-sheet>
      </div>
  </v-sheet>
</template>

<script>
import Tiptap from '@/components/Tiptap.vue'
import PageHeader from "@/components/PageHeader";
export default {
  name: "AddPost",
  components: {PageHeader, Tiptap},
  data() {
    return {
      valid: false,
      tab: null,
      selectedImage: null,
      uploadingImage: false,
      uploadError: "",
      loadingCloudinaryImages: false,
      cloudinaryError: "",
      cloudinaryImages: [],
      deletingPublicId: null,
      deleteImageDialog: false,
      pendingDeleteImage: null,
      post: {
        image: "",
        header: "",
        header_en: null,
        header_ru: null,
        body: "",
        body_en: null,
        body_ru: null,
        date: "",
      },
      rules: [
        value => {
          if (value) return true
          return 'Ei saa olla tühi.'
        },
      ]
    };
  },
  methods: {
    async addPost() {
      const { valid } = await this.$refs.form.validate()

      if (valid) {
        var data = {
          image: this.post.image,
          header: this.post.header,
          header_en: this.post.header_en,
          header_ru: this.post.header_ru,
          body: this.post.body,
          body_en: this.post.body_en,
          body_ru: this.post.body_ru,
        };
        fetch(`${process.env.VUE_APP_SERVER_URL}/api/posts`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
            .then((response) => {
              console.log(response.data);
              location.assign("/uudised");
            })
            .catch((e) => {
              console.log(e);
              console.log("error");
            });
      }
    },
    getHeader(content) {
      return (this.$i18n.locale === 'en' && content.header_en !== null) ? content.header_en : (this.$i18n.locale === 'ru' && content.header_ru !== null) ? content.header_ru : content.header;
    },
    getBody(content) {
      return (this.$i18n.locale === 'en' && content.body_en !== null) ? content.body_en : (this.$i18n.locale === 'ru' && content.body_ru !== null) ? content.body_ru : content.body;
    },
    async fetchCloudinaryImages() {
      this.loadingCloudinaryImages = true;
      this.cloudinaryError = "";
      try {
        const response = await fetch(`${process.env.VUE_APP_SERVER_URL}/api/uploads/images?t=${Date.now()}`, {
          method: "GET",
          credentials: "include",
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || "Failed to load Cloudinary images");
        this.cloudinaryImages = data;
      } catch (error) {
        this.cloudinaryError = "Cloudinary piltide laadimine ebaõnnestus";
        console.log(error);
      } finally {
        this.loadingCloudinaryImages = false;
      }
    },
    async uploadImage(fileInput) {
      const file = Array.isArray(fileInput) ? fileInput[0] : fileInput;
      if (!file) return;
      this.uploadError = "";
      this.uploadingImage = true;
      try {
        const formData = new FormData();
        formData.append("image", file);
        const response = await fetch(`${process.env.VUE_APP_SERVER_URL}/api/uploads/image`, {
          method: "POST",
          body: formData,
          credentials: "include",
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || "Image upload failed");
        this.post.image = data.url;
        this.selectedImage = null;
      } catch (error) {
        this.uploadError = "Pildi üleslaadimine ebaõnnestus";
        console.log(error);
      } finally {
        this.uploadingImage = false;
      }
    },
    openDeleteCloudinaryDialog(image) {
      this.pendingDeleteImage = image;
      this.deleteImageDialog = true;
    },
    closeDeleteCloudinaryDialog() {
      this.deleteImageDialog = false;
      this.pendingDeleteImage = null;
    },
    async confirmDeleteCloudinaryImage() {
      const image = this.pendingDeleteImage;
      if (!image?.public_id) return;

      this.cloudinaryError = "";
      this.deletingPublicId = image.public_id;

      try {
        const response = await fetch(`${process.env.VUE_APP_SERVER_URL}/api/uploads/image`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({ public_id: image.public_id }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || "Image delete failed");

        this.cloudinaryImages = this.cloudinaryImages.filter((item) => item.public_id !== image.public_id);
        if (this.post.image === image.url) {
          this.post.image = "";
        }
      } catch (error) {
        this.cloudinaryError = "Pildi kustutamine ebaõnnestus";
        console.log(error);
      } finally {
        this.deletingPublicId = null;
        this.closeDeleteCloudinaryDialog();
      }
    },
    changeLocale(value) {
      this.$i18n.locale = value;
    }
  },
}
</script>

<style scoped>
.v-list-item-title {
  white-space: break-spaces;
  line-height: 1em;
}

.post-container {
  border-width: thin;
}

.error-text {
  color: #b00020;
  margin-top: -8px;
  margin-bottom: 12px;
}

.cloudinary-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
  margin-bottom: 20px;
}

.cloudinary-item {
  position: relative;
  border: 2px solid transparent;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  padding: 0;
  background: transparent;
}

.cloudinary-item.selected {
  border-color: #4caf50;
}

.cloudinary-item img {
  display: block;
  width: 100%;
  height: 120px;
  object-fit: cover;
}

.cloudinary-delete {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  color: #fff;
  background: rgba(176, 0, 32, 0.85);
}

@media (max-width: 940px) {
  .preview-post-column {
    width: 100%;
  }

  .preview-post-container {
    border: none;
    margin-top: 20px;
    padding: 0 !important;
  }

  .preview-post-container img {
    padding: 20px 0;
  }
}

@media (max-width: 820px) {
  .post-body {
    padding: 0 20px !important;
  }
}
</style>
